import type { ClientContactType } from '@econtractor/types';
import SolarIcon from 'components/icons/SolarIcon';
import { CLIENT_CONTACT_TYPE_CONFIG } from './model/clientContactTypes';

interface ContactTypeIconProps {
    type: ClientContactType;
}

const ContactTypeIcon = ({ type }: ContactTypeIconProps) => {
    const config = CLIENT_CONTACT_TYPE_CONFIG[type];

    return (
        <span
            className="d-inline-flex align-items-center justify-content-center me-2"
            style={{ width: 24, height: 24, flex: '0 0 24px' }}
        >
            {config.imgSrc ? (
                <img src={config.imgSrc} alt="" width={24} height={24} className="rounded" />
            ) : (
                <SolarIcon name={config.solarName || 'info-circle'} className="fs-16 text-body" />
            )}
        </span>
    );
};

export default ContactTypeIcon;
